import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import BusinessDetails from 'components/BusinessDetails';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const TabContainer = props =>
  <div style={{ padding: 20 }}>
    {props.children}
  </div>;

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styleSheet = (theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing.unit * 3,
  },
  paper: {
    padding: 16
  }
});

class CenteredTabs extends Component {
  state = {
    index: 0,
  };

  handleChange = (event, index) => {
    this.setState({ index });
  };

  render() {
    const classes = this.props.classes;

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Tabs
            index={this.state.index}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab label="Business Details" />
            <Tab label="Personal Details" />
            <Tab label="Business Data" />
          </Tabs>
        </Paper>
        <Paper className={classes.paper}>
          {
            this.state.index === 0 &&
              <TabContainer>
                <BusinessDetails />
              </TabContainer>
          }
          {
            this.state.index === 1 &&
              <TabContainer>
                {'Item Two'}
              </TabContainer>
          }
          {
            this.state.index === 2 &&
              <TabContainer>
                {'Item Three'}
              </TabContainer>
          }
        </Paper>
      </div>
    );
  }
}

CenteredTabs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(CenteredTabs);



// WEBPACK FOOTER //
// ./src/components/Stepper/index.js